import { LatLng, LatLngExpression } from 'leaflet';
import {
  AircraftAvailabilityView,
  CSAssignmentCandidate,
  OcsConsoleData,
  RSAssignmentCandidate,
  RSContractorAssignmentCandidate,
} from '@/api/apis/resources';
import { SegmentTypeEnum, RouteLegTypeEnum, AviaLegTypes, GroundLegTypes, RouteLocationType } from '@/api/apis/route';
import { RoutePlanResources } from '@/types/route';

export enum AircraftStatusEnum {
  onDuty = 'onDuty',
  reserved = 'reserved',
  onRest = 'onRest',
  unavailable = 'unavailable',
}

export enum MarkerTypeEnum {
  hub = 'hub',
  aircraft = 'aircraft',
  donorHospital = 'donorHospital',
  txCenter = 'txCenter',
  surgeon = 'surgeon',
  clinicalSpecialist = 'clinicalSpecialist',
}

export enum MapFilterType {
  aircraft = 'aircraft',
  ocsDevices = 'ocsDevices',
  clinicalSpecialists = 'clinicalSpecialists',
  surgeon = 'surgeon',
  showReserved = 'showReserved',
  from = 'from',
  to = 'to',
}

export type HubMarkerType = {
  type: MarkerTypeEnum.hub;
  id: string;
  code: string;
  name: string;
  location: LatLngExpression;
  devices?: OcsConsoleData[];
  clinicalSpecialists?: CSAssignmentCandidate[];
};

export type HospitalMarkerType = {
  type: MarkerTypeEnum.donorHospital;
  id: string;
  code: string | null;
  location: LatLng;
};

export type TxCenterMarkerType = {
  type: MarkerTypeEnum.txCenter;
  id: string;
  code: string;
  location: LatLng;
};

export type AircraftMarkerListItem = Pick<
  AircraftAvailabilityView,
  'id' | 'availabilities' | 'reservations' | 'registration' | 'latitude' | 'longitude'
> & { flightTimeMs?: number; status: AircraftStatusEnum };

export type AircraftMarkerType = {
  type: MarkerTypeEnum.aircraft;
  id: string;
  name: string;
  timezone: string;
  location: LatLng;
  list: Pick<
    AircraftAvailabilityView,
    'id' | 'availabilities' | 'reservations' | 'registration' | 'latitude' | 'longitude'
  >[];
};

type SurgeonMarkerTypeBase = {
  type: MarkerTypeEnum.surgeon;
  id: string;
  location: LatLng;
  item: RSAssignmentCandidate | RSContractorAssignmentCandidate;
};

export type SurgeonMarkerType = SurgeonMarkerTypeBase & {
  isContractor: false;
  item: RSAssignmentCandidate;
};

export type ContractorSurgeonMarkerType = SurgeonMarkerTypeBase & {
  isContractor: true;
  item: RSContractorAssignmentCandidate;
};

export type CSMarkerType = {
  type: MarkerTypeEnum.clinicalSpecialist;
  id: string;
  location: LatLng;
  item: CSAssignmentCandidate;
};

export type MapMarkerType =
  | HubMarkerType
  | HospitalMarkerType
  | TxCenterMarkerType
  | AircraftMarkerType
  | SurgeonMarkerType
  | ContractorSurgeonMarkerType
  | CSMarkerType;

export enum AvailabilityFilterType {
  Now = 'Now',
  ORTime = 'OR time',
  Custom = 'Custom',
}

export enum LegConnectorConnectionType {
  inbetween = 'inbetween',
  startToEnd = 'start-to-end',
}

export type RoutePolylineType = {
  id: string;
  type: SegmentTypeEnum;
  legType: RouteLegTypeEnum;
  positions: LatLngExpression[] | LatLngExpression[][];
  direction: 'left' | 'right';
  index: string;
  middlePosition?: LatLngExpression;
  zoomLevel?: number;
};

export type RouteMarkerType = {
  id: string;
  location: LatLngExpression;
};

export type FboMarkerType = {
  type: SegmentTypeEnum;
  code: string;
  title: string;
} & RouteMarkerType;

export type HighlightedRouteType = {
  id: string;
  legs: (AviaLegTypes | GroundLegTypes)[];
  resources: Partial<RoutePlanResources>;
  locations: RouteLocationType[];
};
